import * as types from "./types";

export default {
  [types.MUTATE_CERTIFICATE_TYPES](state, payload) {
    state.certificateTypes = payload;
  },

  [types.MUTATE_CERTIFICATES_SEARCH_RESULT](state, payload) {
    state.certificatesSearchResult = payload;
  },

  [types.MUTATE_NEW_CERTIFICATE_TYPE_SIDEBAR](state, payload) {
    state.newCertificateTypeSidebar = {
      ...state.newCertificateTypeSidebar,
      ...payload,
    };
  },
  [types.MUTATE_MANAGE_CERTIFICATE_TYPES_SIDEBAR](state, payload) {
    state.manageCertificateTypesSidebar = { 
      ...state.manageCertificateTypesSidebar, 
      ...payload
    };
  },
  
};